import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that only updates `delayMs` after the
 * last change — coalescing rapid edits into a single downstream update.
 *
 * Used to keep expensive, key-driven queries (holdings preview, the eligible
 * universe resolved at the reconstitution date) from refetching on every
 * intermediate keystroke/drag while the user is still editing.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
